module.exports = __webpack_public_path__ + "img/coupon.eb3f1a6.svg";